import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Spin, Typography } from 'antd';
import AuthLayout from '../../layouts/AuthLayout';
import useAuth from '../../hooks/useAuth';
import useClientProfile from '../../hooks/useClientProfile';
import { getPlanByCode } from '../../services/plans';
import { createCheckoutSession } from '../../services/stripe';

const BLOCKING_STATUSES = ['ACTIVE', 'PENDING'];

export default function CheckoutPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { profile, loading: profileLoading } = useClientProfile();
  const [statusMsg, setStatusMsg] = useState('Preparando tu membresía...');
  const hasStarted = useRef(false);

  useEffect(() => {
    console.log('[Checkout] user:', user?.id, '| profileLoading:', profileLoading);
    if (!user || profileLoading) return;
    if (hasStarted.current) return;
    hasStarted.current = true;

    async function processCheckout() {
      const planCode = searchParams.get('plan');
      console.log('[Checkout] planCode:', planCode, '| subscription:', profile?.subscription?.status);

      if (!planCode) {
        console.log('[Checkout] ERROR: no planCode');
        navigate('/checkout/error?reason=not-found', { replace: true });
        return;
      }

      try {
        setStatusMsg('Buscando el plan...');
        const plan = await getPlanByCode(planCode);
        console.log('[Checkout] plan encontrado:', plan);

        if (!plan) {
          console.log('[Checkout] ERROR: plan no encontrado');
          navigate('/checkout/error?reason=not-found', { replace: true });
          return;
        }

        if (BLOCKING_STATUSES.includes(profile?.subscription?.status)) {
          console.log('[Checkout] ERROR: ya suscrito');
          navigate('/checkout/error?reason=already-subscribed', { replace: true });
          return;
        }

        setStatusMsg('Redirigiendo al pago...');
        console.log('[Checkout] Creando sesión Stripe para user:', user.id, 'plan:', plan.id);
        const { url } = await createCheckoutSession(user.id, plan.id);
        console.log('[Checkout] Stripe URL:', url);
        if (!url) {
          navigate('/checkout/error?reason=error', { replace: true });
          return;
        }
        window.location.href = url;
      } catch (err) {
        console.error('[Checkout] ERROR:', err);
        navigate('/checkout/error?reason=error', { replace: true });
      }
    }

    processCheckout();
  }, [user, profile, profileLoading, searchParams, navigate]);

  return (
    <AuthLayout>
      <div style={{ textAlign: 'center', padding: '48px 24px' }}>
        <Spin size="large" style={{ marginBottom: 24 }} />
        <Typography.Text style={{ display: 'block', color: 'rgba(255,255,255,0.65)', marginTop: 16 }}>
          {statusMsg}
        </Typography.Text>
      </div>
    </AuthLayout>
  );
}
